import { createI18n } from 'vue-i18n';

function loadLocaleMessages() {
    const locales = import.meta.glob('./locales/**/*.json', { eager: true });
    const messages = {};
    Object.keys(locales).forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\.json$/i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales[key].default || locales[key];
        }
    });
    return messages;
}

function defaultChoiceIndex(choice, choicesLength) {
    const _choice = Math.abs(choice);
    if (choicesLength === 2) return _choice ? (_choice > 1 ? 1 : 0) : 1;
    return _choice ? Math.min(_choice, 2) : 0;
}

function rusChoiceIndex(choice, choicesLength) {
    if (choice === 0) return 0;
    const teen = Math.abs(choice) % 100 >= 11 && Math.abs(choice) % 100 <= 14;
    const endsWithOne = choice % 10 === 1;
    if (!teen && endsWithOne) return 1;
    if (!teen && choice % 10 >= 2 && choice % 10 <= 4) return 2;
    return choicesLength < 4 ? 2 : 3;
}

// if (window.location.href.indexOf('lang=eng') > 0) {
//     localStorage.setItem('speechki-locale', 'eng');
// } else if (window.location.href.indexOf('lang=rus') > 0) {
//     localStorage.setItem('speechki-locale', 'rus');
// } else if (!localStorage.getItem('speechki-locale')) {
//     if (window.navigator.language.slice(0, 2) === 'ru') {
//         localStorage.setItem('speechki-locale', 'rus');
//     } else {
//         localStorage.setItem('speechki-locale', 'eng');
//     }
// }

export default createI18n({
    legacy: true,
    // locale: localStorage.getItem('speechki-locale') || 'eng',
    locale: 'eng',
    fallbackLocale: 'eng',
    messages: loadLocaleMessages(),
    silentTranslationWarn: process.env.NODE_ENV === 'production',
    pluralizationRules: { rus: rusChoiceIndex, eng: defaultChoiceIndex }
});
